export {
  createRestClient,
  type ClientOf,
  type RestClientOptions,
  type RouteCallOptions,
  type RouteMethod,
  type RouteOperation,
} from './client'
